<script>
import { Bar } from 'vue-chartjs'
import _map from 'lodash/map'

export default {
  name: 'BarChart',
  extends: Bar,
  props: {
    data: {
      type: Array,
      required: true,
    },
    categoryList: {
      type: Array,
      required: true,
    },
    datasets: {
      type: Array,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({
        legend: { position: 'bottom' },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 1,
              offset: true,
              suggestedMax: 5,
            },
          }],
        },
      }),
    },
  },
  computed: {
    chartdata () {
      return {
        labels: _map(this.categoryList, 'value'),
        datasets: this.datasets.map(({ field, ...dataset }) => ({
          ...dataset,
          data: this.categoryList
            .map(category => this.data.filter(item => item[field] === category.key).length),
        })),
      }
    },
  },
  watch: {
    chartdata () {
      this.renderChart(this.chartdata, this.options)
    },
  },
  mounted () {
    this.renderChart(this.chartdata, this.options)
  },
}
</script>
